class ReviewsSlider {
	constructor(reviewsElement) {
		this.reviewsElement = reviewsElement;
		this.swiper = null;
		
		this.init();
	}
	
	init() {
		this.initializeSwiper();
	}
	
	initializeSwiper() {
		const swiperContainer = this.reviewsElement.querySelector('.reviews-swiper');
		const swiperContainerForNavigation = this.reviewsElement.querySelector('.swiper-container');
		
		if (!swiperContainer) {
			return;
		}
		
		this.swiper = new Swiper(swiperContainer, {
			slidesPerView: 1,
			spaceBetween: 30,
			loop: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true
			},
			// pagination: {
			// 	el: swiperContainerForNavigation.querySelector('.swiper-pagination'),
			// 	clickable: true,
			// 	type: 'bullets'
			// },
			navigation: {
				nextEl: swiperContainerForNavigation.querySelector('.swiper-button-next'),
				prevEl: swiperContainerForNavigation.querySelector('.swiper-button-prev'),
			},
			breakpoints: {
				767: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				}
			},
			on: {
				init: () => {
					//console.log('Reviews swiper initialized');
				}
			}
		});
	}
	
	destroy() {
		if (this.swiper) {
			this.swiper.destroy(true, true);
		}
	}
}

// Initialize all reviews sliders on the page
export function initReviews() {
	const reviewsElements = document.querySelectorAll('.section-flexible--reviews');
	const reviewsInstances = [];
	
	reviewsElements.forEach(reviewsElement => {
		const instance = new ReviewsSlider(reviewsElement);
		reviewsInstances.push(instance);
	});
	
	return reviewsInstances;
}
